<template>
    <div class="body-wrapper">
        <div class="container-fluid">
            <div class="card card-body">
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="d-sm-flex align-items-center justify-space-between">
                            <h4 class="fw-semibold fs-4 mb-4 mb-md-0 card-title">Adicionar Colaborador</h4>
                            <nav aria-label="breadcrumb" class="ms-auto">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item" aria-current="page">
                                        <router-link to="/colaboradores" type="submit" class="btn btn-primary btn-sm hstack gap-6">
                                        <i class="ti ti-arrow-back fs-4"></i>
                                        Voltar para lista
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title mb-3">Informações Básicas</h4>

                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-floating mb-3">
                                        <input v-model="name" type="text" class="form-control" id="tb-fname"
                                            placeholder="Nome Completo"/>
                                        <label for="tb-fname">Nome Completo</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="email" type="email" class="form-control" id="tb-email"
                                            placeholder="E-mail" />
                                        <label for="tb-email">E-mail (Ex.: teste@teste.com)</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-floating mb-3">
                                        <input v-model="phone" type="text" class="form-control" id="tb-fname"
                                            placeholder="Telefone" v-maska="'(##) #####-####'"/>
                                        <label for="tb-fname">Telefone</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-floating mb-3">
                                        <input v-model="cpf" type="text" class="form-control" id="tb-fname"
                                            placeholder="Telefone" v-maska="'###.###.###-##'"/>
                                        <label for="tb-fname">CPF</label>
                                    </div>
                                </div>
                            </div>

                            <h4 class="card-title mb-3 mt-5">Endereço</h4>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-floating mb-3">
                                        <input v-model="zip_code" type="text" class="form-control" id="tb-fname" placeholder="CEP" v-maska="'#####-###'"  @change="searchCEP"/>
                                        <label for="tb-fname">CEP</label>
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="form-floating mb-3">
                                        <input v-model="street" type="email" class="form-control" id="tb-email" placeholder="Rua" />
                                        <label for="tb-email">Rua (Ex.: Rua das neves)</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-floating mb-3">
                                        <input v-model="street_number" type="text" class="form-control" id="tb-fname" placeholder="CEP" />
                                        <label for="tb-fname">Número</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="neighbohood" type="email" class="form-control" id="tb-email"
                                            placeholder="Bairro" />
                                        <label for="tb-email">Bairro</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="city" type="email" class="form-control" id="tb-email"
                                            placeholder="Cidade" />
                                        <label for="tb-email">Cidade</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="state" type="email" class="form-control" id="tb-email"
                                            placeholder="Estado" />
                                        <label for="tb-email">Estado</label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-5">
                                <div class="form-floating mb-3">
                                    <input v-model="complement" type="text" class="form-control" id="tb-fname"
                                        placeholder="Complemento" />
                                    <label for="tb-fname">Complemento</label>
                                </div>
                            </div>

                            <h4 class="card-title mb-3 mt-5">Acesso</h4>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="password" type="password" class="form-control" id="tb-pwd"
                                            placeholder="Senha" />
                                        <label for="tb-pwd">Senha</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-floating mb-3">
                                        <input v-model="re_password" type="password" class="form-control" id="tb-cpwd"
                                            placeholder="Re-Senha" />
                                        <label for="tb-cpwd">Re-Senha</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-12">
                                    <div class="d-md-flex align-items-center">
                                        <div class="ms-auto mt-3 mt-md-0">
                                            <button class="btn btn-primary hstack gap-6" @click="create">
                                                <i class="ti ti-plus fs-4"></i>
                                                Adicionar Colaborador
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Cookies from 'js-cookie';
import App from '@/App.vue';

export default {
    mixins: [
        App
    ],
    data() {
        return {
            role: 0,
            name: '',
            email: '',
            phone: '',
            cnpj: '',
            responsible: '',
            cpf: '',
            password: '',
            re_password: '',
            zip_code: '',
            street: '',
            street_number: '',
            neighbohood: '',
            city: '',
            state: '',
            complement: '',
            role_id: 4,
        }
    },
    methods: {
        create(){
            const json = {
                name: this.name,
                email: this.email,
                phone: this.phone,
                cpf: this.cpf,
                password: this.password,
                re_password: this.re_password,
                zip_code: this.zip_code,
                street: this.street,
                street_number: this.street_number,
                neighbohood: this.neighbohood,
                city: this.city,
                state: this.state,
                complement: this.complement,
                role_id: this.role_id,
            }

            this.$http.post('/users', json, {
                headers: {
                    'Authorization': 'Bearer ' + Cookies.get('_token')
                }
            }).then( (response) => {
                this.showAlert('success',response.data.message);
                this.$router.push('/colaboradores');
            }).catch( (error) => {
                console.log(error)
                this.showAlert('error', error.response.data);
            });
        },
        searchCEP(){
            if(!this.zip_code || this.zip_code.length < 9 || this.zip_code_old == this.zip_code){
                return;
            }

            this.$http.get('/cep/'+this.zip_code)
            .then( (response) =>{
                this.zip_code_old = this.zip_code;
                this.street= response.data.logradouro;
                this.neighbohood = response.data.bairro;
                this.city= response.data.localidade;
                this.state= response.data.uf;

            }).catch((error) => {
                if (error.response && error.response.data) {
                    this.showAlert('error', error.response.data);
                } else {
                this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento.');
                }
            })
        }
    },
    created(){
        this.role = this.$store.state.role;
    }
}
</script>


